<div [ngClass]="mode">
  <pdq-checkbox
    style="pointer-events: none"
    labelSize="small"
    [label]="template.config.checkboxText"
    [checked]="template.config.defaultCheckboxState"
    [secondaryLabel]="template.config.checkboxHelpText">
  </pdq-checkbox>
</div>
